export default "__VITE_ASSET__Ca5MMmNE__"